// src/constants/api-endpoints.js

// Base URL (adaptera automatiquement selon l'environnement)
export const API_BASE = process.env.VUE_APP_API_URL || '';

// Racines de services backend (identiques aux routes gateway)
export const API_PATHS = {
    REGISTRY: '/registry',
    PRODUCT: '/product-service',
    PURCHASE: '/purchase-service',
    SALE: '/sale-service',
    CNTIPEE_SERVICE: '/cntippee-service',
    NOTIFICATION: '/notification-service',
    STORAGE: '/storage-service'
};

// Quelques helpers pratiques
export const API = {
    // === REGISTRY ===
    REGISTRY_CATEGORIES: `${API_PATHS.REGISTRY}/categories`,
    REGISTRY_CATEGORY_ID: (id) => `${API_PATHS.REGISTRY}/categories/${id}`,
    REGISTRY_CATEGORY_DELETE: (id) => `${API_PATHS.REGISTRY}/categories/${id}`,

    REGISTRY_FAMILIES: `${API_PATHS.REGISTRY}/families`,
    REGISTRY_FAMILY_ID: (id) => `${API_PATHS.REGISTRY}/families/${id}`,
    REGISTRY_FAMILY_DELETE: (id) => `${API_PATHS.REGISTRY}/families/${id}`,

    REGISTRY_UNITS: `${API_PATHS.REGISTRY}/units`,
    REGISTRY_UNIT_ID: (id) => `${API_PATHS.REGISTRY}/units/${id}`,
    REGISTRY_UNIT_DELETE: (id) => `${API_PATHS.REGISTRY}/units/${id}`,

    // === PRODUCT ===
    PRODUCT_END_POINT: `${API_PATHS.PRODUCT}/products`,
    PRODUCT_DETAIL: (id) => `${API_PATHS.PRODUCT}/products/${id}`,
    PRODUCT_DELETE: (id) => `${API_PATHS.PRODUCT}/products/${id}`,
    PRODUCT_HISTORY: (id) => `${API_PATHS.PRODUCT}/${id}/stock-movements`,

    // === PROJECT === 🚀
    PROJECT_CREATE: `${API_PATHS.CNTIPEE_SERVICE}/project`,
    PROJECT_GET: (code) => `${API_PATHS.CNTIPEE_SERVICE}/project/${code}`,
    PROJECT_UPDATE: (code) => `${API_PATHS.CNTIPEE_SERVICE}/project/${code}`,
    PROJECT_DELETE: (code) => `${API_PATHS.CNTIPEE_SERVICE}/project/${code}`,
    PROJECT_SEARCH: `${API_PATHS.CNTIPEE_SERVICE}/project/search`,

    // =====================================================
    // === MARKET TYPE ===
    // =====================================================/marketType/{code}
    MARKET_TYPE_CREATE: `${API_PATHS.CNTIPEE_SERVICE}/marketType`,
    MARKET_TYPE_GET: (code) => `${API_PATHS.CNTIPEE_SERVICE}/marketType/${code}`,
    MARKET_TYPE_UPDATE: (code) => `${API_PATHS.CNTIPEE_SERVICE}/marketType/${code}`,
    MARKET_TYPE_DELETE: (code) => `${API_PATHS.CNTIPEE_SERVICE}/marketType/${code}`,
    MARKET_TYPE_SEARCH: `${API_PATHS.CNTIPEE_SERVICE}/marketType/search`,

    // =====================================================
    // === MARKET CATEGORY ===
    // =====================================================
    MARKET_CATEGORY_CREATE: `${API_PATHS.CNTIPEE_SERVICE}/marketCategory`,
    MARKET_CATEGORY_GET: (code) => `${API_PATHS.CNTIPEE_SERVICE}/marketCategory/${code}`,
    MARKET_CATEGORY_UPDATE: (code) => `${API_PATHS.CNTIPEE_SERVICE}/marketCategory/${code}`,
    MARKET_CATEGORY_DELETE: (code) => `${API_PATHS.CNTIPEE_SERVICE}/marketCategory/${code}`,
    MARKET_CATEGORY_SEARCH: `${API_PATHS.CNTIPEE_SERVICE}/marketCategory/search`,

    // =====================================================
    // === DOCUMENT TYPE ===
    // =====================================================
    DOCUMENT_TYPE_CREATE: `${API_PATHS.CNTIPEE_SERVICE}/documentType`,
    DOCUMENT_TYPE_GET: (code) => `${API_PATHS.CNTIPEE_SERVICE}/documentType/${code}`,
    DOCUMENT_TYPE_UPDATE: (code) => `${API_PATHS.CNTIPEE_SERVICE}/documentType/${code}`,
    DOCUMENT_TYPE_DELETE: (code) => `${API_PATHS.CNTIPEE_SERVICE}/documentType/${code}`,
    DOCUMENT_TYPE_SEARCH: `${API_PATHS.CNTIPEE_SERVICE}/documentType/search`,


    // === STORAGE ===
    STORAGE_UPLOAD: `${API_PATHS.STORAGE}/upload`
};
